import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import api from './api';

const { Option } = Select;

const ApiSelect = ({ 
    apiUrl, 
    labelKey = 'name', 
    valueKey = 'id', 
    searchKey = 'search',
    params = {}, 
    pageSize = 10,
    placeholder,
    onChange,
    value,
    allowClear = true,
    onOptionsLoaded
}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadData();
    }, [JSON.stringify(params)]);

    const loadData = async (searchValue = '') => {
        setLoading(true);
        try {
            const queryParams = {
                currentPage: 1,
                pageSize: 100, // Load more for select
                ...params
            };
            if (searchValue && searchKey) {
                queryParams[searchKey] = searchValue;
            }

            const res = await api.get(apiUrl, { params: queryParams });
            const list = res?.data?.list || res?.list || [];
            const options = list.map(item => ({
                value: item[valueKey],
                label: item[labelKey]
            }));
            setData(options);
            
            if (onOptionsLoaded) {
                onOptionsLoaded(options);
            }
        } catch (error) {
            console.error("Failed to load data for select:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (val) => {
        if (searchKey) {
            loadData(val);
        }
    };

    return (
        <Select
            showSearch
            placeholder={placeholder}
            optionFilterProp="children"
            onSearch={handleSearch}
            onChange={(val, option) => onChange(val, option)}
            value={value}
            loading={loading}
            allowClear={allowClear}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: '100%' }}
            options={data}
        />
    );
};

export default ApiSelect;
